"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var server_1 = require("react-dom/server");
function pointFormatter(options, usePoint) {
    return function () {
        var renderContent = options.renderContent, labelPrefix = options.labelPrefix, labelSuffix = options.labelSuffix, valuePrefix = options.valuePrefix, valueSuffix = options.valueSuffix, valueDecimals = options.valueDecimals;
        var _a = this, x = _a.x, color = _a.color, colorIndex = _a.colorIndex, _b = _a.options, y = _b.y, low = _b.low, high = _b.high, pointValue = _b.value, seriesLabel = _a.series.name, pointLabel = _a.name;
        var jsx;
        var label = usePoint ? pointLabel : seriesLabel;
        var details = {
            label: label,
            x: x,
            y: y,
            low: low,
            high: high,
            pointValue: pointValue,
            colorIndex: colorIndex
        };
        if (this.series.xAxis && this.series.xAxis.categories) {
            details.xCategory = this.series.xAxis.categories[x];
        }
        if (this.series.yAxis && this.series.yAxis.categories) {
            details.yCategory = this.series.yAxis.categories[y];
        }
        if (renderContent) {
            jsx = React.createElement("div", { className: "highcharts-tooltip-content" }, renderContent(details));
        }
        else {
            var value = void 0;
            if (low && high) {
                value = low.toFixed(valueDecimals) + " - " + high.toFixed(valueDecimals);
            }
            else if (pointValue) {
                value = pointValue.toFixed(valueDecimals);
            }
            else {
                value = y.toFixed(valueDecimals);
            }
            jsx = (React.createElement("div", { className: "highcharts-tooltip-content" },
                React.createElement("span", { className: "highcharts-tooltip-label-marker", style: { color: color } }, '\u25CF'),
                React.createElement("span", { className: "highcharts-tooltip-label" },
                    labelPrefix,
                    label,
                    labelSuffix,
                    ":",
                    ' '),
                React.createElement("span", { className: "highcharts-tooltip-value" },
                    valuePrefix,
                    value,
                    valueSuffix)));
        }
        return server_1.renderToString(jsx);
    };
}
exports.pointFormatter = pointFormatter;
function default_1(base, tooltip, usePoint) {
    var showTooltips = base.showTooltips, chartType = base.chartType;
    var options = {
        enabled: showTooltips,
        useHTML: true,
        borderRadius: 0,
        borderWidth: 0,
        shadow: false,
        valueDecimals: 2,
        style: { fontFamily: 'inherit' },
        padding: 6
    };
    if (chartType === 'basic') {
        options.headerFormat = '';
    }
    if (options.enabled === false) {
        options.pointFormatter = function () {
            return '';
        };
    }
    else {
        options.pointFormatter = pointFormatter(options, usePoint);
    }
    if (tooltip) {
        var _a = tooltip.props, labelPrefix = _a.labelPrefix, labelSuffix = _a.labelSuffix, valuePrefix = _a.valuePrefix, valueSuffix = _a.valueSuffix, renderContent = _a.renderContent, overrides = __rest(_a, ["labelPrefix", "labelSuffix", "valuePrefix", "valueSuffix", "renderContent"]);
        if (overrides.shared) {
            overrides.split = false;
        }
        if (overrides.enabled === false) {
            options.pointFormatter = function () {
                return '';
            };
        }
        else {
            overrides.pointFormatter = pointFormatter(__assign(__assign(__assign({}, options), overrides), { labelPrefix: labelPrefix,
                labelSuffix: labelSuffix,
                valuePrefix: valuePrefix,
                valueSuffix: valueSuffix,
                renderContent: renderContent }), usePoint);
        }
        options = __assign(__assign({}, options), overrides);
    }
    return options;
}
exports.default = default_1;
//# sourceMappingURL=tooltipOptions.js.map